function _templateObject5() {
  const data = _taggedTemplateLiteral(["\n          display: flex;\n          flex-direction: row-reverse;\n          justify-content: flex-end;\n          > * {\n            width: 50%;\n          }\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n          display: block;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n  width: auto;\n  padding: 0;\n  ", ";\n  @media screen and (max-width: ", ") {\n    display: block;\n    > * {\n      width: 100%;\n    }\n  }\n  .tabsContent & {\n    margin: 0 -10px;\n  }\n\n  .content-pactos-barrasSimple {\n    .bloque-pactometro {\n      @media screen and (min-width: 580px) {\n        width: 100%;\n        margin: 5px 0px 5px;\n      }\n    }\n  }\n  .content-pactosSimple {\n    .pactos {\n      .row-pactometro {\n        @media screen and (min-width: 768px) {\n          width: 33.333%;\n        }\n        @media screen and (min-width: 980px) {\n          width: 50%;\n        }\n      }\n    }\n    label {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n            width: ", "%;\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -5px;\n  .item-partido {\n    padding: 5px;\n    width: 100%;\n  }\n  .row-pactometro {\n    padding: 5px 5px;\n    box-sizing: border-box;\n    width: 50%;\n    @media screen and (min-width: 480px) {\n      width: 33.333%;\n    }\n    @media screen and (min-width: 764px) {\n      width: 25%;\n    }\n    ", ";\n\n    input[type=\"checkbox\"] {\n      position: absolute;\n      left: -999em;\n    }\n    label {\n      cursor: pointer;\n      display: block;\n      font-size: 13px;\n      margin-bottom: 0;\n      min-height: 30px;\n      overflow: hidden;\n      padding: 5px 40px 5px 5px;\n      position: relative;\n      text-align: left;\n      background: #f7f7f7;\n      span {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n        display: block;\n        line-height: 1.1;\n      }\n      p {\n        color: #6c6c6c;\n        font-size: 12px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        margin: 0;\n        line-height: 1;\n      }\n      &::after {\n        background: #c5c5c5;\n        bottom: 0;\n        content: \"\";\n        display: block;\n        height: 27px;\n        position: absolute;\n        right: 5px;\n        top: 5px;\n        width: 27px;\n        z-index: 2;\n      }\n      &:hover {\n        &::after {\n          background: #b9b9b9;\n        }\n      }\n    }\n    &::before {\n      content: \"\";\n      height: 7px;\n      left: 0;\n      position: absolute;\n      top: 0;\n      width: 5px;\n      z-index: 1;\n    }\n    input[type=\"checkbox\"] {\n      &:checked {\n        & ~ label {\n          &::after {\n            background: #007201 url(", ") no-repeat\n              50% 50%;\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from "styled-components";
import { mobileMax } from "../../constants";
export const SCPactometroCheck = styled.div(_templateObject(), props => props.cols !== undefined ? css(_templateObject2(), 100 / (props.cols || 2)) : "", props => props.labelCheckImage);
export const SCContainerPactometroSimple = styled.div(_templateObject3(), props => props.cols === 1 ? css(_templateObject4()) : css(_templateObject5()), mobileMax);